import { TagType } from '../tags';

export type Topic = {
  topicId: string;
  topicName: string;
};

export type SectionOption = {
  sectionId: string;
  sectionName: string;
};

export type Company = {
  companyName: string;
  companyId: string;
};

export type Assignee = {
  isTagMember?: boolean;
  studentName: string;
  yearOfPassing: string;
  emailId: string;
  mobileNumber: string;
  studentId: string;
  branch: string;
  selected?: boolean;
};

export type CustomTestSections = {
  id: string;
  sectionId: string;
  topics: string[];
  questionsCount: number;
  timeLimit: number; // in minutes
};

export type ScheduleTestBase = {
  organizer: string;
  tag?: TagType;
  testName: string;
  windowStartDate: string;
  windowEndDate: string;
  description: string;
  instructions: string;
  assignees: Assignee[];
};

export type CompanyTestSchedule = ScheduleTestBase & {
  testType: 'company';
  company: Company;
};

export type CustomTestSchedule = ScheduleTestBase & {
  testType: 'custom';
  sections: CustomTestSections[];
};

export type ScheduleTest = CompanyTestSchedule | CustomTestSchedule;

export type TestType = 'company' | 'custom';

export const isCompanyTest = (
  test: ScheduleTest
): test is CompanyTestSchedule => {
  return test.testType === 'company';
};

export const isCustomTest = (
  test: ScheduleTest
): test is CustomTestSchedule => {
  return test.testType === 'custom';
};

export type ISOString = string;
